/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Overview_Reopen_RegistrationInputs */



/**
* | output |
* | --- |
* | "Reopen Registration" |
*
* @param {Overview_Reopen_RegistrationInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const overview_reopen_registration = /** @type {((inputs?: Overview_Reopen_RegistrationInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Overview_Reopen_RegistrationInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rouvrir les inscriptions")
	if (locale === "es") return /** @type {LocalizedString} */ ("Reabrir inscripción")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Reabrir Inscrições")
	if (locale === "it") return /** @type {LocalizedString} */ ("Riapri Iscrizione")
	return /** @type {LocalizedString} */ ("Reopen Registration")
});